module.exports = __webpack_public_path__ + "img/seller3.1e3ccb1f.jpg";